import Vue from "vue";
import Vuex from "vuex";
import sessions from "./modules/SessionStates";
import createLogger from "./logger";
import createVuexAlong from "vuex-along";

Vue.use(Vuex);

const debug = true;
const alongOptions = {
  name: "qyb-vuex-along",
  local: {
    list: ["sessions"],
    isFilter: false
  },
  session: {
    list: ["sessions"]
  }
};

export default new Vuex.Store({
  modules: {
    sessions
  },
  strict: debug,
  plugins: debug ? [createLogger(), createVuexAlong(alongOptions)] : []
});



// WEBPACK FOOTER //
// ./src/util/store/index.js